import { createAsyncThunk } from '@reduxjs/toolkit'
import { getCrashGameReportService, getSlotGameListElementsService, getSlotGameReportService } from 'network/services/game.service'
import { getAllGamesReportService, getTopPlayerReportService } from 'network/services/reports/gameReports.service'

export const fetchCrashGameReport = createAsyncThunk(
  'fetch/crashGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getCrashGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchSlotGameListElements = createAsyncThunk(
  'fetch/slot-game-pay-table',
  async (data, thunkApi) => {
    try {
      const res = await getSlotGameListElementsService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchSlotGameReport = createAsyncThunk(
  'fetch/slotGameReport',
  async (data, thunkApi) => {
    try {
      const res = await getSlotGameReportService(data)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchAllGamesReport = createAsyncThunk(
  'fetch/allGamesReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getAllGamesReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)

export const fetchTopPlayerReport = createAsyncThunk(
  'fetch/topPlayerReport',
  async ({ params }, thunkApi) => {
    try {
      const res = await getTopPlayerReportService(params)
      return res
    } catch (error) {
      return thunkApi.rejectWithValue(error[0].description)
    }
  }
)
